import { inject, observer } from 'mobx-react';
import * as React from 'react';

import SsoStore from '../stores/SsoStore';
import CustomerType from './CustomerType';

interface IsB2BProps {
  ssoStore?: SsoStore;
  visibleForLoggedOutUsers?: boolean;
  children?: React.ReactNode;
}

@observer
class IsB2B extends React.Component<IsB2BProps> {
  private isVisible = () => {
    const { ssoStore, visibleForLoggedOutUsers } = this.props;
    return ssoStore.loggedIn ? ssoStore.customer?.type === CustomerType.B2B : visibleForLoggedOutUsers;
  };

  public render() {
    return this.isVisible() ? <>{this.props.children}</> : null;
  }
}

export default inject('ssoStore')(IsB2B);
